// import React from "react";

// const MyAddress = () => {
//   return (
//     <div className="card profile-card border-0">
//       <div className="card-body">
//         <h5 className="card-title">My Addresses</h5>

//         <div className="address-box">
//           <p><strong>Home</strong></p>
//           <p>Nagpur, Maharashtra</p>
//           <p>India - 440001</p>

//           <div className="address-actions">
//             <button className="btn btn-outline-primary btn-sm">Edit</button>
//             <button className="btn btn-outline-danger btn-sm ms-2">Delete</button>
//           </div>
//         </div>

//         <button className="button3 mt-3">
//           Add New Address
//         </button>
//       </div>
//     </div>
//   );
// };

// export default MyAddress;


import React, { useEffect, useState } from "react";
import axios from "axios";

const BASE_URL = "https://ecom.cyberathon.com/index.php/Api";

const MyAddress = () => {
  const userId = sessionStorage.getItem("userId");

  const [addresses, setAddresses] = useState([]);
  const [editAddress, setEditAddress] = useState(null);

  // 🔹 List Address
  const getAddresses = async () => {
    const res = await axios.post(`${BASE_URL}/list_billing_address`, {
      user_id: userId,
    });
    if (res.data.status) {
      setAddresses(res.data.data);
    }
  };

  useEffect(() => {
    getAddresses();
  }, []);

  // 🔹 Update Address
  const updateAddress = async () => {
    const res = await axios.post(
      `${BASE_URL}/update_billing_address`,
      editAddress
    );

    if (res.data.status) {
      alert("Address Updated Successfully");
      setEditAddress(null);
      getAddresses();
    }
  };

  // 🔹 handle change
  const handleChange = (e) => {
    setEditAddress({
      ...editAddress,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="card profile-card border-0">
      <div className="card-body">
        <h5 className="card-title">My Addresses</h5>

        {/* 🔹 ADDRESS LIST */}
        {addresses.map((item) => (
          <div className="address-box mb-3" key={item.billing_id}>
            <p><strong>{item.address_type}</strong></p>
            <p>{item.address1}, {item.city}</p>
            <p>{item.state} - {item.pin_code}</p>

            <div className="address-actions">
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => setEditAddress(item)}
              >
                Edit
              </button>
            </div>
          </div>
        ))}

        {/* <button className="button3 mt-3">Add New Address</button> */}

        {/* 🔹 EDIT FORM (AUTOFILL) */}
        {editAddress && (
          <div className="mt-4">
            <h5>Edit Address</h5>

            <input
              className="form-control mb-2"
              name="first_name"
              value={editAddress.first_name}
              onChange={handleChange}
              placeholder="First Name"
            />

            <input
              className="form-control mb-2"
              name="last_name"
              value={editAddress.last_name}
              onChange={handleChange}
              placeholder="Last Name"
            />

            <input
              className="form-control mb-2"
              name="address1"
              value={editAddress.address1}
              onChange={handleChange}
              placeholder="Address"
            />

            <input
              className="form-control mb-2"
              name="city"
              value={editAddress.city}
              onChange={handleChange}
              placeholder="City"
            />

            <input
              className="form-control mb-2"
              name="state"
              value={editAddress.state}
              onChange={handleChange}
              placeholder="State"
            />

            <input
              className="form-control mb-2"
              name="pin_code"
              value={editAddress.pin_code}
              onChange={handleChange}
              placeholder="Pincode"
            />

            <button className="btn btn-success" onClick={updateAddress}>
              Update Address
            </button>

            <button
              className="btn btn-secondary ms-2"
              onClick={() => setEditAddress(null)}
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyAddress;
